import {Hydra} from '../generic/hydra';

import {CommissionSeanceInterface} from './CommissionSeance';
import {DossierInterface} from './Dossier';
import {ProjetDureeInterface} from './ProjetDuree';
import {Decision as DecisionBaseInterface} from '../../interface/api/Decision';
import {FichierInterface} from "./Fichier";

export type DecisionInterface = DecisionBaseInterface;

export class Decision extends Hydra implements DecisionInterface {

    id?: number | null;

    commissionSeance?: CommissionSeanceInterface | string | null;

    dossier?: DossierInterface | string | null;

    /*
     *  1 = accepté,
     *  2 = refusé,
     *  3 = liste complémentaire,
     *  5 = liste d'attente,
     *  7 = accepté et dupliqué
     *
     */
    decision?: number | null;

    montantAccorde?: number | null;

    dureeAccordee?: ProjetDureeInterface|string | null;

    ordre?: number | null;

    commentaire?: string | null;

    /* Readonly
     */
    notificationSent?: boolean | null = false;

    /* Readonly
     */
    notificationPending?: boolean | null = false;

    dateCreation?: string | Date | null;

    dateDerniereModification?: string | Date | null;

    /* Readonly
     */
    notifiable?: boolean | null;

    /* Readonly
     */
    modifiable?: boolean | null;

    /* Readonly
     */
    configFinancementValide?: boolean | null;

    fichierNotification?: FichierInterface | string | null;


    constructor(options: DecisionInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
